import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CurrentUserService } from "src/app/shared/services/current-user.service";
import { Subject, EMPTY, BehaviorSubject } from "rxjs";
import { takeUntil, catchError, finalize } from "rxjs/operators";
import { IUser } from "src/app/admin/users/models/IUser";
import { MustMatch } from "src/app/shared/validators/must-match.validator";
import { UsersService } from "src/app/admin/users/users.service";
import { Location } from "@angular/common";
import { AuthService } from "src/app/shared/services/auth.service";
import {PtoService} from "../../shared/services/pto.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  private destroy = new Subject<any>();
  private savingSubject = new BehaviorSubject<boolean>(false);
  saving$ = this.savingSubject.asObservable();

  user: IUser;
  changePasswordForm: FormGroup;
  failedSubmitAttempt = false;
  submissionErrors: string[] = [];
  calendarUrl: string;

  get currentPasswordControl() {
    return this.changePasswordForm.controls.currentPassword;
  }
  get newPasswordControl() {
    return this.changePasswordForm.controls.newPassword;
  }
  get newPasswordConfirmControl() {
    return this.changePasswordForm.controls.newPasswordConfirm;
  }

  constructor(
    private fb: FormBuilder,
    currentUserService: CurrentUserService,
    private userService: UsersService,
    private ptoService: PtoService,
    private authService: AuthService,
    private location: Location
  ) {
    currentUserService.currentUserData$
      .pipe(takeUntil(this.destroy))
      .subscribe((userData) => {
        this.user = userData;
      });
  }

  ngOnInit() {
    this.changePasswordForm = this.fb.group(
      {
        currentPassword: ["", Validators.required],
        newPassword: [
          "",
          Validators.compose([Validators.required, Validators.minLength(6)]),
        ],
        newPasswordConfirm: ["", Validators.required],
      },
      { validators: [MustMatch("newPassword", "newPasswordConfirm")] }
    );
  }
  ngOnDestroy() {
    this.destroy.next();
  }
  submit() {
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }
    this.savingSubject.next(true);
    const userId = this.authService.getUserId();
    this.userService
      .changeUserPassword(userId, this.changePasswordForm.value)
      .pipe(
        catchError((e) => {
          this.failedSubmitAttempt = true;
          this.submissionErrors = this.parseError(e);
          this.changePasswordForm.markAsUntouched();
          return EMPTY;
        }),
        finalize(() => {
          this.savingSubject.next(false);
        })
      )
      .subscribe((r) => {
        // TODO toast!
        // go back to where we came from
        this.location.back();
      });
  }
  private parseError(e): string[] {
    const errors: string[] = [];

    if (e.status === 404) {
      errors.push("User not found, refresh and try again.");
    } else if (typeof e.error === "string") {
      errors.push(e.error);
    } else if (Array.isArray(e.error)) {
      errors.push.apply(errors, e.error);
    } else {
      errors.push("Something went wrong...");
    }

    return errors;
  }

  generateCalendarUrl() {
    const userId = this.authService.getUserId();
    this.ptoService
      .generateCalendarUrl()
      .subscribe((response) => {
        this.calendarUrl = response.url;
      });
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      console.log('URL copied to clipboard');
    });
  }
}
